import { render, staticRenderFns } from "./publicaciones.vue?vue&type=template&id=4aa0650b&"
import script from "./publicaciones.vue?vue&type=script&lang=ts&"
export * from "./publicaciones.vue?vue&type=script&lang=ts&"
import style0 from "./publicaciones.vue?vue&type=style&index=0&id=4aa0650b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports